/**
 * Utilitaire pour encoder correctement les URLs des vidéos
 * Gère les espaces, caractères spéciaux et chemins en production
 */

/**
 * Encode correctement une URL de vidéo pour qu'elle fonctionne en production
 * @param {string} url - L'URL du fichier vidéo (peut contenir des espaces et caractères spéciaux)
 * @returns {string} - L'URL encodée correctement
 */
// Normalise un nom de fichier pour le CDN : espaces -> tirets
const normalizeFilename = (name = '') =>
  name
    .trim()
    .replace(/\s+/g, '-');

export const encodeVideoUrl = (url) => {
  if (!url) return '';
  
  // Base des vidéos externes (optionnelle)
  const baseUrl =
    process.env.REACT_APP_VIDEO_BASE_URL || '';
  const publicBase = process.env.PUBLIC_URL || '';
  const localPlaylistPrefix = '/assets/videos/playlist synchro sound design  /';
  
  // Playlist sound design locale (dossier avec espaces) :
  // on garde le dossier tel quel mais on normalise le nom de fichier.
  if (url.startsWith(localPlaylistPrefix)) {
    const fileName = url.slice(localPlaylistPrefix.length);
    const normalizedFile = normalizeFilename(fileName);
    return `${publicBase}${localPlaylistPrefix}${encodeURIComponent(normalizedFile)}`;
  }

  // Vidéo locale absolue (racine) : on la remappe vers /assets/videos avec nom normalisé.
  if (url.startsWith('/')) {
    const fileName = url.split('/').pop() || '';
    const normalizedFile = normalizeFilename(fileName);
    return `${publicBase}/assets/videos/${encodeURIComponent(normalizedFile)}`;
  }

  // Si une base externe est fournie, on encode pour le CDN
  if (baseUrl) {
    const encodedUrl = `${baseUrl}/${encodeURIComponent(normalizeFilename(url))}`;
    return encodedUrl;
  }

  // Sinon fallback 100% local dans /assets/videos
  return `${publicBase}/assets/videos/${encodeURIComponent(normalizeFilename(url))}`;
};

/**
 * Prépare les URLs des vidéos pour qu'elles fonctionnent en production
 * @param {Array} videos - Tableau d'objets vidéo avec une propriété 'url'
 * @returns {Array} - Tableau avec les URLs encodées
 */
export const prepareVideoUrls = (videos) => {
  if (!Array.isArray(videos)) return [];
  
  return videos.map(video => ({
    ...video,
    url: encodeVideoUrl(video.url)
  }));
};

